export default __webpack_public_path__ + "static/media/mobile.0350bb3a.svg";